"use strict";
angular.module("weixinToBeCompiledRouterModule", []).
config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {
  $stateProvider.state('front.editctr.weixin.waitcompiled', {
    url: '/waitcompiled?wxchannelid&siteid',//为了修订功能增加siteid
    views: {
      "main@front.editctr": {
        templateUrl: "./editingCenter/weixin/toBeCompiled/main_tpl.html",
        controller: "weixinToBeCompiledCtrl"
      }
    }
  });
}]);
